import React from 'react';
import { ITaskProps } from '../model/types/task-props.interface';

export function BoardTask({
    title,
    type,
    isDone,
    dateFinished,
    dateStart,
    tags,
    createdAt,
    children,
}: ITaskProps) {
    return <li>{title}</li>;
}
